import type { OrgPodPayRes } from '@lingtu/apis/entities';

import { defineStore } from 'pinia';
import to from 'await-to-js';
import { store } from '/@/store';
import { apis } from '/@/apis';
import { useOrgStoreWithOut } from './org';

interface PodPayState {
  podPayInfo: OrgPodPayRes | null;
  orgId: string | number | null;
  fetching: boolean;
}

export const usePodPayStore = defineStore({
  id: 'pod-pay',
  state: (): PodPayState => ({
    podPayInfo: null,
    orgId: null,
    fetching: false,
  }),
  getters: {
    /** 是否是 POD 付费会员 */
    isPayMember(): boolean {
      return !!this.podPayInfo?.pay;
    },
    /** 是否是 299 套餐 */
    isLowPlan(): boolean {
      return !!this.podPayInfo?.low;
    },
    /** 当前是否为个人套餐 - 599套餐 */
    isPersonalPlan(): boolean {
      return !!this.podPayInfo?.personal;
    },
    /** 是否可使用会员专属群服务 */
    hasGroupService(): boolean {
      return !!this.podPayInfo?.pay && !this.podPayInfo?.personal;
    },
  },
  actions: {
    reset() {
      this.podPayInfo = null;
      this.orgId = null;
    },

    async getPodPay() {
      const currentOrgId = useOrgStoreWithOut().orgInfo?.id ?? null;
      if (this.podPayInfo && this.orgId === currentOrgId) {
        return this.podPayInfo;
      }
      return this.updatePodPay();
    },

    async updatePodPay() {
      if (this.fetching) {
        return await new Promise<OrgPodPayRes | null>((resolve) => {
          this.$subscribe(() => {
            if (!this.fetching) {
              resolve(this.podPayInfo);
            }
          });
        });
      }

      this.fetching = true;
      const [err, res] = await to(apis.ems.getOrgPodPay());
      this.podPayInfo = err ? null : res;
      this.orgId = useOrgStoreWithOut().orgInfo?.id ?? null;
      this.fetching = false;
      return this.podPayInfo;
    },
  },
});

export function usePodPayStoreWithOut() {
  return usePodPayStore(store);
}
